export default __webpack_public_path__ + "static/media/0061.1ed8bf71.jpg";